import { render } from "./UserDropdown.vue?vue&type=template&id=1d42e77a"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script